/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "./IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






function Index(props) {
  const main = useRef();
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
  },[]);


  return (
    <>
      <DemoNavbar />
      <main ref={main} className="howto-page">
        <Container fluid="lg" className="m-auto white-container">
          <Row className="mb-4">
            <Col md="12">
                <h1 className="text-center"><b>How to Order</b></h1>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xl="3" lg="6"  className="text-center howto-box">
              <div className="circle-header">
                <b>1</b>
              </div>
              <div className="border-box">
                <div className="box-header">
                  <h4 className="mb-0"><b>Select Quote</b></h4>
                  <p><b>(Button Below)</b></p>
                </div>
                <div className="box-content">
                  *You can view your previous
                  orders and visual concepts.
                  From there you can select a
                  previous order for Re-ordering.
                </div>
              </div>
            </Col>
            <Col xl="3" lg="6"  className="text-center howto-box">
              <div className="circle-header">
                <b>2</b>
              </div>
              <div className="border-box">
                <div className="box-header">
                  <h4><b>Choose your<br/>garments</b></h4>
                </div>
                <div className="box-content">
                  Add garments to your order order
                  by entering in the SKU code.
                  *Tip - minimising the number of
                  catalogues you are selecting
                  from will avoid un-needed
                  service fees.
                </div>
              </div>
            </Col>
            <Col xl="3" lg="6"  className="text-center howto-box">
              <div className="circle-header">
                <b>3</b>
              </div>
              <div className="border-box">
                <div className="box-header">
                  <h4><b>Choose your<br/>decoration</b></h4>
                </div>
                <div className="box-content">
                  Select Brand Management
                  options, such as Embroidery or
                  Screen Print, by ticking boxes next
                  to the garments you are ordering.
                  A member of the Brand
                  Management team will review
                  your decoration requirements.
                </div>
              </div>
            </Col>
            <Col xl="3" lg="6"  className="text-center howto-box">
              <div className="circle-header">
                <b>4</b>
              </div>
              <div className="border-box">
                <div className="box-header">
                  <h4><b>Upload your logo<br/>and submit</b></h4>
                </div>
                <div className="box-content">
                  If you have worked with us before,
                  then we are already Managing
                  your Brand<br/>
                  If you haven't worked with us yet,
                  then please upload your logo.
                  *PDF/EPS are required and
                  style-guides are priceless!
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md="12" className="d-flex justify-content-center">
              <button className="mr-4 btn-icon btn btn-primary btn-lg"  onClick={()=>props.history.push("/requests/add")}>New Quote</button>
              <button className="btn-icon btn btn-primary btn-lg" onClick={()=>props.history.push("/myorders")}>Previous Orders</button>
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
